import {
  Link,
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";

import { useAuth } from "../context/AuthContext";

function LaunchIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

function AccountIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="17"
      height="17"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
    </svg>
  );
}

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function signOut() {
    await logout();
    navigate("/", { replace: true });
  }

  return (
    <div className="site-shell">
      <header className="topbar">
        <Link
          to="/"
          className="brand"
          aria-label="SARADIUM home"
        >
          <img
            src="/saradium-icon.svg"
            alt=""
            width="38"
            height="38"
          />

          <span>SARADIUM</span>
        </Link>

        <nav
          className="site-navigation"
          aria-label="Main navigation"
        >
          <div className="site-navigation-links">
            <NavLink to="/features">
              Features
            </NavLink>

            <NavLink to="/pricing">
              Pricing
            </NavLink>

            <NavLink to="/support">
              Support
            </NavLink>
          </div>

          <div className="site-navigation-actions">
            {user ? (
              <>
                <NavLink
                  className="open-saradium-button"
                  to="/app/routines"
                >
                  <span>Open SARADIUM</span>
                  <LaunchIcon />
cial                                </NavLink>

                <NavLink
                  className="account-navigation-button"
                  to="/account"
                  aria-label="Open account"
                >
                  <AccountIcon />
                  <span>Account</span>
                </NavLink>

                <button
                  type="button"
                  className="sign-out-navigation-button"
                  onClick={signOut}
                >
                  Sign out
                </button>
              </>
            ) : (
              <>
                <NavLink
                  className="sign-in-navigation-link"
                  to="/login"
                >
                  Sign in
                </NavLink>

                <NavLink
                  className="create-account-navigation-button"
                  to="/register"
                >
                  Create account
                </NavLink>
              </>
            )}
          </div>
        </nav>
      </header>

      <main>
        <Outlet />
      </main>

      <footer>
        <div>
          <Link
            to="/"
            className="brand footer-brand"
          >
            <img
              src="/saradium-icon.svg"
              alt=""
              width="34"
              height="34"
            />

            <span>SARADIUM</span>
          </Link>

          <p>Set a reminder. Do it.</p>
        </div>

        <div className="footer-links">
          {user && (
            <Link
              className="footer-open-saradium"
              to="/app/routines"
            >
              Open SARADIUM
              <LaunchIcon />
            </Link>
          )}

          <Link to="/features">
            Features
          </Link>

          <Link to="/pricing">
            Pricing
          </Link>

          <Link to="/support">
            Support
          </Link>

          <Link to="/privacy">
            Privacy
          </Link>

          <Link to="/terms">
            Terms
          </Link>
        </div>

        <small>
          © {new Date().getFullYear()} SARADIUM.
          All rights reserved.
        </small>
      </footer>
    </div>
  );
}